module.exports = __webpack_public_path__ + "img/investment-plan-mobile@3x.94b05099.webp";